<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <header-menu/>
                </ion-buttons>
            </template>
        </default-header>

        <ion-content fullscreen>
            <flash-messages/>

            <div v-if="loading" style="margin: 200px 0; display: flex; justify-content: center;">
                <ion-spinner></ion-spinner>
            </div>

            <ion-grid v-show="! loading">
                <ion-row>
                    <ion-col style="max-width: 800px;">
                        <h2 style="margin-top: 2px;">
                            {{ $t('ncrypt.covid_saliva_other_user_scan.title') }}
                        </h2>

                        <div style="float: left; width: 100%;">
                            <div ref="scanner"
                                 style="position:relative; z-index: 1; max-width: 1280px; max-height: 60vh;"></div>
                        </div>

                        <div style="float: left; width: 100%;">
                            <p>
                                {{ $t('ncrypt.covid_saliva_scan.scanned_code_label') }}

                                <input type="text" readonly :value="scannedSalivaCode" style="background: #eee;"/>
                            </p>

                            <p>
                                {{ $t('ncrypt.covid_saliva_scan.scanned_user_number_code_label') }}

                                <input type="text" readonly :value="scannedUserUid" style="background: #eee;"/>
                            </p>

                            <!--                            <p>-->
                            <!--                                Gescande verificatiecode:-->

                            <!--                                <input type="text" readonly :value="scannedVerificationCode" style="background: #eee;"/>-->
                            <!--                            </p>-->

                            <br/>

                            <ion-button @click="submit()"
                                        :disabled="! canSubmit"
                                        expand="block"
                                        size="default"
                                        shape="round"
                                        style="margin: 0 auto;">
                                {{ $t('ncrypt.covid_saliva_scan.submit_scanned_code') }}
                            </ion-button>

                            <ion-button @click="reset()"
                                        fill="outline"
                                        color="danger"
                                        size="small"
                                        shape="round"
                                        style="margin: 30px auto 0;">
                                {{ $t('ncrypt.covid_saliva_scan.reset_scans') }}
                            </ion-button>
                        </div>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col style="max-width: 800px; margin-top: 15px;">
                        <h3>{{ $t('ncrypt.covid_saliva_scan.history') }}</h3>
                        <table style="width: 100%; max-width: 440px;">
                            <thead>
                            <tr>
                                <th style="padding: 4px; text-align: left; width: 150px;">{{ $t('ncrypt.covid_saliva_scan.date') }}</th>
                                <th style="padding: 4px; text-align: left;">{{ $t('ncrypt.covid_saliva_scan.barcode') }}</th>
                                <th style="padding: 4px; text-align: left;">{{ $t('ncrypt.covid_saliva_scan.user_number_code') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(scan, i) in scanHistory" :key="`${i}-${scan.id}`">
                                <td style="padding: 4px;">{{ scan.scan_date }}</td>
                                <td style="padding: 4px; word-break: break-word;">{{ scan.barcode }}</td>
                                <td style="padding: 4px; word-break: break-word;">
                                    {{ scan.uid }}

                                    <span v-if="$store.getters.user && $store.getters.user.uid === scan.uid" style="font-size: 85%;">
                                        ({{ $t('ncrypt.covid_saliva_scan.this_is_your_own_user_code') }})
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import HeaderMenu from "../../components/nav/HeaderMenu";
    import {ApiError} from "@/errors/ApiError";
    import {Notifier} from "@/services/Notifier";
    import {ErrorHandler} from "@/services/ErrorHandler";
    import {Scanner} from "@/services/Scanner";

    export default {
        components: {
            HeaderMenu,
            FlashMessages,
            DefaultHeader,
        },
        data() {
            return {
                loading: true,
                scannedSalivaCode: null,
                // scannedSalivaCode: 783123712938,
                scannedUserUid: null,
                // scannedUserUid: 4824756,
                //scannedVerificationCode: null,
                scanHistory: [],
            };
        },
        computed: {
            canSubmit() {
                return this.scannedUserUid && this.scannedSalivaCode;//&& this.scannedVerificationCode;
            },
        },
        methods: {
            async bootScanner() {
                this.loading = false;

                await this.$nextTick();

                const scanner = await Scanner.create(this.$refs.scanner, [
                    'code39',
                    'code128',
                ]);

                scanner.on('scan', scanResult => {
                    if (! Array.isArray(scanResult.barcodes) || ! scanResult.barcodes.length) {
                        return;
                    }

                    scanResult.barcodes.forEach((barcodeData) => {
                        switch (barcodeData.symbology) {
                            case 'code39':
                                this.scannedSymbology39Code(barcodeData);
                                break;
                            case 'code128':
                                this.scannedSymbology128Code(barcodeData);
                                break;
                        }
                    });
                });
            },
            scannedSymbology39Code(barcodeData) {
                const barcodeValue = barcodeData.data;

                if (! this.scannedUserUid) {
                    this.scannedUserUid = barcodeValue;
                    return;
                }

                if (barcodeValue === this.scannedUserUid) {
                    return;
                }

                if (! document.querySelector('ion-alert')) {
                    Notifier.showAlert({
                        header: 'Error',
                        message: this.$t('ncrypt.covid_scan.error.already_scanned_previous_code_submit_or_reset'),
                        buttons: ['OK'],
                    });
                }
            },
            scannedSymbology128Code(barcodeData) {
                const barcodeValue = barcodeData.data;

                if (! this.scannedSalivaCode) {
                    this.scannedSalivaCode = barcodeValue;
                    return;
                }

                if (barcodeValue === this.scannedSalivaCode) {
                    return;
                }

                if (! document.querySelector('ion-alert')) {
                    Notifier.showAlert({
                        header: 'Error',
                        message: this.$t('ncrypt.covid_scan.error.already_scanned_previous_code_submit_or_reset'),
                        buttons: ['OK'],
                    });
                }
            },
            reset() {
                this.scannedSalivaCode = null;
                this.scannedUserUid = null;
                // this.scannedVerificationCode = null;

                this.loadScanHistory();
            },
            async submit() {
                if (! this.scannedSalivaCode) {
                    return;
                }

                await Notifier.showAlert({
                    header: this.$t('ncrypt.covid_saliva_other_user_scan.submit_confirmation.title'),
                    message: this.$t('ncrypt.covid_saliva_other_user_scan.submit_confirmation.message'),
                    buttons: [
                        {
                            text: this.$t('ncrypt.covid_saliva_other_user_scan.submit_confirmation.button_proceed'),
                            handler: () => {
                                this.$http.post('/covid-passport/submit-non-self-barcode', {
                                    barcode: this.scannedSalivaCode,
                                    uid: this.scannedUserUid,
                                    // verification_code: this.scannedVerificationCode,
                                })
                                    .then(async response => {
                                        await Notifier.showAlert({
                                            header: 'Scanresultaat',
                                            message: ErrorHandler.buildApiErrorMessage(response),
                                            buttons: ['OK'],
                                        });

                                        this.reset();
                                    })
                                    .catch(reason => new ApiError(reason));
                            },
                        },
                        {
                            text: this.$t('ncrypt.covid_saliva_other_user_scan.submit_confirmation.button_abort'),
                        },
                    ],
                });
            },
            loadScanHistory() {
                this.$http.get('/covid-passport/barcode-history')
                    .then(async response => {
                        if (response.status >= 300) {
                            new ApiError(response);
                            return;
                        }

                        this.scanHistory = response.data.scans.filter(scanData => scanData.uid);
                    })
                    .catch(reason => new ApiError(reason));
            },
        },
        mounted() {
            this.bootScanner();

            this.loadScanHistory();
        },
    }
</script>
